export default __webpack_public_path__ + "static/media/juego1_instrucciones.ff2742b3.png";